import { render } from "./LawExams.vue?vue&type=template&id=9dc65474"
import script from "./LawExams.vue?vue&type=script&lang=js"
export * from "./LawExams.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__